<div edsGrid>
  <div edsRow>
    <div edsCol>
      <eds-section-header
        [title]="titleLabel | translate: fundId"
        [level]="3"
        [size]="'h3'"
        [asOfLabel]="'products.as-at' | translate: fundId"
        [asOfDate]="navData.navAsOfDate"
        edsSpacing="md"
      ></eds-section-header>
    </div>
  </div>
  <div edsRow edsSpacing="md">
    <div edsCol *ngIf="navData">
      <ft-share-prices
        [navData]="navData"
        [config]="config"
        [fundId]="fundId"
      ></ft-share-prices>
    </div>
  </div>
  <div edsRow edsSpacing="md">
    <div edsCol [columnNumbers]="{ s: 4, m: 4, l: 5 }" *ngIf="showWeekRange">
      <ft-week-range [weeksData]="weeksData" [fundId]="fundId"></ft-week-range>
    </div>
    <div
      edsCol
      [columnNumbers]="{ s: 4, m: 4, l: 5 }"
      *ngIf="showPremiumDiscountData"
    >
      <ft-premium-discount
        [premiumDiscountData]="premiumDiscountData"
        [asOfDate]="navData.navAsOfDate"
        [fundId]="fundId"
      ></ft-premium-discount>
    </div>
    <div
      edsCol
      [columnNumbers]="{ s: 4, m: 4, l: 5 }"
      *ngIf="showSalesChargeBreakPointsData"
    >
      <ft-pop-sales-charge-breakpoints
        [salesChargeBreakPointsData]="salesChargeBreakPointsData"
        [fundId]="fundId"
      ></ft-pop-sales-charge-breakpoints>
    </div>
  </div>
</div>
